var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62143 0.518555L3.42857 0.9375H0.857143C0.383036 0.9375 0 1.35645 0 1.875C0 2.39355 0.383036 2.8125 0.857143 2.8125H11.1429C11.617 2.8125 12 2.39355 12 1.875C12 1.35645 11.617 0.9375 11.1429 0.9375H8.57143L8.37857 0.518555C8.23393 0.199219 7.93661 0 7.6125 0H4.3875C4.06339 0 3.76607 0.199219 3.62143 0.518555ZM11.1429 3.75H0.857143L1.425 13.6816C1.46786 14.4229 2.03036 15 2.70804 15H9.29196C9.96964 15 10.5321 14.4229 10.575 13.6816L11.1429 3.75Z",
    fill: "#373939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.2214c9bfbd1cf34d757079114b67a348.svg";
export { ForwardRef as ReactComponent };